const BRAND = 'SevenSix';

function formatCategory(product) {
    if (!product || !product.category) {
        return undefined;
    }

    return product.category.name_full || product.category.name || undefined;
}

function formatProduct(product, options = {}) {
    if (!product) {
        return null;
    }

    const item = product.product || product;
    const size = product.size || options.size || null;
    const price = options.price !== undefined
        ? options.price
        : (product.price_real !== undefined ? product.price_real : item.price);

    const result = {
        id: String(item.sku || item.id),
        name: item.name,
        brand: BRAND,
        price: Number(price || 0),
    };

    const category = formatCategory(item);
    if (category) {
        result.category = category;
    }

    const quantity = options.quantity !== undefined
        ? options.quantity
        : (product.quantity !== undefined ? product.quantity : undefined);
    if (quantity !== undefined) {
        result.quantity = Number(quantity);
    }

    const variant = options.variant || (size ? (size.size || size.name) : null);
    if (variant) {
        result.variant = variant;
    }

    if (options.list) {
        result.list = options.list;
    }

    if (options.position) {
        result.position = options.position;
    }

    return result;
}

function pushEcommerce(payload) {
    if (!process.client || !payload) {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        ecommerce: payload,
    });
}

export default ({ app }, inject) => {
    const currencyCode = app.$config.siteCountry === 'kz' ? 'KZT' : 'RUB';

    inject('ecommerce', {
        impressions(products, list) {
            const items = Array.isArray(products) ? products : [];
            const formatted = items
                .map((product, index) => formatProduct(product, {
                    list,
                    position: index + 1,
                }))
                .filter(Boolean);

            if (!formatted.length) {
                return;
            }

            pushEcommerce({
                currencyCode,
                impressions: formatted,
            });
        },
        detail(product) {
            const formatted = formatProduct(product);
            if (!formatted) {
                return;
            }

            pushEcommerce({
                currencyCode,
                detail: {
                    products: [formatted],
                },
            });
        },
        add(product, options = {}) {
            const formatted = formatProduct(product, {
                ...options,
                quantity: options.quantity || 1,
            });
            if (!formatted) {
                return;
            }

            pushEcommerce({
                currencyCode,
                add: {
                    products: [formatted],
                },
            });
        },
        remove(product, options = {}) {
            const formatted = formatProduct(product, options);
            if (!formatted) {
                return;
            }

            pushEcommerce({
                currencyCode,
                remove: {
                    products: [formatted],
                },
            });
        },
    });
};
